import React, { useState } from "react";
import "../../../../Assets/CSS/bulkorder.css";
import "../../oms.css";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import ImageIcon from "@mui/icons-material/Image";
import { Box, Button } from "@mui/material";
import { ClipLoader } from "react-spinners";
import axios from "axios";
import toast from "react-hot-toast";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import ShowPDF from "../../common/pdfViewer";
import { Modal } from "@material-ui/core";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";

function SupplierContractExecution({ getOMSData, omsData }) {
  const isPending =
    omsData?.only_bnps?.ayekart_lvl1_status !== "Approved" ||
    omsData?.only_bnps?.ayekart_lvl2_status !== "Approved";
  const [uploading, setUploading] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");
  const [activeModal, setActiveModal] = useState(false);

  const contractDoc =
    omsData?.order_shipment_docs?.find(osd => osd.merchant_type === 'supplier')?.supplier_contract_execution_document_oms || "";

  const onFileChange = async (event) => {
    const files = event.target.files;
    if (files.length > 0) {
      setUploading(true);
      const uploadPromises = Array.from(files).map(async (file) => {
        const formData = new FormData();
        formData.append("file", file);
        try {
          const uploadResponse = await fetch(
            "/upload/mitra-merchant/doc-upload",
            {
              method: "POST",
              body: formData,
            }
          );

          if (uploadResponse.ok) {
            const uploadResponseData = await uploadResponse.json();
            handleSubmit(uploadResponseData?.file_location);
          } else {
            throw new Error("Failed to upload file.");
          }
        } catch (error) {
          setUploading(false);
          console.error("Error uploading file:", error);
        }
      });

      try {
        await Promise.all(uploadPromises);
        setUploading(false);
      } catch (error) {
        setUploading(false);
        console.error("Error uploading files:", error);
      }
    }
  };

  const handleModalClose = () => {
    setPdfUrl("");
    setActiveModal(false);
  };

  const handleModalOpen = (pdfUrl) => {
    setPdfUrl(pdfUrl);
    setActiveModal(true);
  };

//   const handleDeleteTruckUnloading = (index) => {
//     // const newState = [...docState.truck_unloading_image_oms];
//     // newState.splice(index, 1);
//     // setDocState((prevState) => ({
//     //   ...prevState,
//     //   truck_unloading_image_oms: newState,
//     // }));
//   };

  const handleSubmit = async (value) => {
    let payload = {
      order_id: omsData?.id,
      merchant_type: "supplier",
      is_oms: true,
      supplier_contract_execution_document_oms: value,
    };
    try {
      const { data } = await axios.post("/api/oms/shipment/docs", payload);
      if (data.status) {
        getOMSData();
        toast.success(data.message);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      toast.error(error.response ? error.response.message : "An error occured");
    }
  };

  return (
    <>
      <Modal
        open={activeModal}
        onClose={handleModalClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            width: "50%",
            height: "80%",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            overflowY: "auto",
          }}
        >
          <div className="">
            <IconButton
              aria-label="close"
              style={{ position: "absolute", right: "8px", top: "8px" }}
              onClick={handleModalClose}
            >
              <CloseIcon />
            </IconButton>
          </div>
          <div className="flex flex-col items-center justify-center space-y-5 h-full">
            {pdfUrl?.toLowerCase().endsWith(".pdf") ? (
              <ShowPDF pdfUrl={pdfUrl} />
            ) : (
              <img src={pdfUrl} alt="uploaded image" />
            )}
          </div>
        </Box>
      </Modal>

      <div className="shadow-lg m-2 p-2 pb-2 rounded-lg">
        <div className="flex flex-col sm:flex-row justify-between">
          <div className="font-medium text-cyan-950 text-md flex gap-2">
            <InsertDriveFileIcon />
            <div>Supplier Contract Execution</div>
            {!contractDoc && (
              <span style={{ color: "red" }}>(Not Uploaded)</span>
            )}
          </div>
          <div></div>
        </div>
        <div>
          <hr className="font-bold text-neutral-500 bg-gray-900 h-0.5" />
        </div>
        <div>
          {false ? (
            <></>
          ) : (
            <div>
              <form>
                <div className="grid grid-cols-1 gap-3">
                  <div className="">
                    <div className="border-2 rounded p-2 ">
                      <div className="text-xl mb-3 text-left">
                        <span>Documents</span>
                      </div>
                      {!contractDoc ? (
                        <div>
                          <div>
                            <i
                              class="fa fa-file-pdf-o fs-1 text-secondary"
                              aria-hidden="true"
                            ></i>
                          </div>
                          <span className="p-1 bg-red-200 rounded mb-2">
                            <span style={{ color: "#fc3503" }}>
                              Not Uploaded
                            </span>
                          </span>
                        </div>
                      ) : (
                        <div className="grid grid-cols-3 gap-3">
                          <div className="border-2 bg-gray-300">
                            {/* <div className="cursor-pointer flex justify-between">
                              <div></div>
                              <div
                                onClick={() =>
                                  handleDeleteTruckUnloading(index)
                                }
                              >
                                <DeleteIcon />
                              </div>
                            </div> */}
                            {(contractDoc?.toLowerCase().endsWith(".jpg") ||
                              contractDoc?.toLowerCase().endsWith(".png") ||
                              contractDoc?.toLowerCase().endsWith(".jpeg")) && (
                              <div>
                                <ImageIcon style={{ fontSize: "60px" }} />
                              </div>
                            )}
                            {contractDoc?.toLowerCase().endsWith(".pdf") && (
                              <div>
                                <FileCopyIcon style={{ fontSize: "60px" }} />
                              </div>
                            )}
                            <div className="p-2">
                              <div>
                                <button
                                  className="bg-blue-500 text-white rounded p-2 mr-2"
                                  onClick={() => handleModalOpen(contractDoc)}
                                  type="button"
                                >
                                  View
                                </button>
                                <button
                                  className="bg-blue-500 text-white rounded p-2"
                                  type="button"
                                >
                                  <a
                                    style={{
                                      textDecoration: "none",
                                      color: "inherit",
                                    }}
                                    href={contractDoc}
                                  >
                                    Download
                                  </a>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      <input
                        id="file"
                        type="file"
                        name="truck_unloading_image"
                        onChange={(e) => {
                          onFileChange(e);
                        }}
                        className="mt-5 ml-5"
                        disabled={isPending || uploading}
                        multiple
                      />
                    </div>
                  </div>
                </div>
                {
                  <div>
                    {uploading ? (
                      <div>
                        <ClipLoader />
                      </div>
                    ) : (
                      <div className="flex justify-end mt-2">
                        <Button
                          variant="contained"
                          size="small"
                          type="submit"
                          sx={{ backgroundColor: "#0D9223" }}
                          disabled={isPending}
                        >
                          SAVE
                        </Button>
                      </div>
                    )}
                  </div>
                }
              </form>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default SupplierContractExecution;
